import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import {
  faBolt,
  faCircle,
  faMousePointer,
  faPenNib,
  faPlus,
} from '@fortawesome/free-solid-svg-icons';
import { AbstractSecondaryToolbar } from '../../../../cross-team-shared/annotation/shared/toolbars/secondary-toolbar/abstract-secondary-toolbar';
import { ToggleButton } from '../../../../cross-team-shared/components/toggle-button-group/toggle-button-group.component';
import { delayExecution } from '../../../../shared/misc-utilities/promise-utils';
import { AbstractSensorContentState2D } from '../../state/abstract-sensor-content-state-2d';
import { AbstractSensorContentStore2D } from '../../state/abstract-sensor-content-store-2d';
import { isClickxActive } from '../polygon/clickx-tool-helper';
import { AddRemoveModeHelperService } from './add-remove-mode-helper.service';
import { EditTool2D } from './edit-tool-2d';

@Component({
  selector: 'h3-edit-secondary-toolbar-2d',
  templateUrl: './edit-secondary-toolbar-2d.component.html',
  styleUrls: ['./edit-secondary-toolbar-2d.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EditSecondaryToolbar2DComponent
  extends AbstractSecondaryToolbar<
    AbstractSensorContentState2D,
    AbstractSensorContentStore2D,
    EditTool2D
  >
  implements AfterViewInit
{
  @ViewChild('clickyIcon', { read: TemplateRef })
  private clickyIcon!: TemplateRef<unknown>;

  @ViewChild('addIcon', { read: TemplateRef })
  private addIcon!: TemplateRef<unknown>;
  faBolt = faBolt;
  faCircle = faCircle;
  faMousePointer = faMousePointer;
  faPlus = faPlus;
  faPenNib = faPenNib;
  buttons: ToggleButton[] = [];

  private store = inject(AbstractSensorContentStore2D);
  private addRemoveModeHelperService = inject(AddRemoveModeHelperService);
  private changeDetectorRef = inject(ChangeDetectorRef);

  ngAfterViewInit() {
    const shouldShowAddMode =
      this.addRemoveModeHelperService.allowIncrementalShapeToolModes();
    if (shouldShowAddMode || this.shouldShowClickyEditModes()) {
      this.buttons.push({ value: 'drag', icon: faMousePointer });
    }

    if (shouldShowAddMode) {
      this.buttons.push({ value: 'add', template: this.addIcon });
    }

    if (this.shouldShowClickyEditModes()) {
      this.buttons.push({ value: 'clicky', template: this.clickyIcon });
    }

    // Note we have to wait until afterViewInit() to get Icons and
    // have to trigger change detection otherwise buttons will not appear
    void delayExecution(() => {
      this.changeDetectorRef.markForCheck();
    });
  }

  private shouldShowClickyEditModes() {
    return isClickxActive(this.store.state().output);
  }
}
